// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"100\" height=\"100\" viewBox=\"0 0 100 100\"><rect width=\"100\" height=\"100\" fill=\"none\" stroke=\"rgba%28255,255,255,0.1%29\" stroke-width=\"2\"/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PANCard_MainContainer__axLvn {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 30px 20px;
  min-height: 100vh;
  background-color: #f8f9fa;
}

.PANCard_MainWrapper__irosl {
  border: none;
  border-radius: 16px;
  background-color: #fff;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
  width: 100%;
  max-width: 550px;
  height: 100%;
  overflow: hidden;
  transition: all 0.3s ease;
}

.PANCard_topPANDiv__IihO1 {
  display: flex;
  align-items: center;
  gap: 15px;
  border-bottom: 1px solid #f0f0f0;
  padding: 20px;
  background: linear-gradient(135deg, #ff7676, #f73439);
  color: white;
}

.PANCard_topPanIcon__hzIrF {
  width: 32px;
  height: 32px;
  object-fit: contain;
  display: block;
}

.PANCard_topPanText__TOt7\\+ {
  font-size: 22px;
  font-weight: 600;
  line-height: 28px;
  color: white;
  margin-top: 0;
  flex-grow: 1;
}

.PANCard_topClockDiv__gpipN {
  display: flex;
  gap: 8px;
  margin-top: 0;
  background-color: rgba(255, 255, 255, 0.2);
  padding: 6px 12px;
  border-radius: 20px;
}

.PANCard_clockIcon__7Na5s {
  height: 18px;
  width: 18px;
  align-self: center;
}

.PANCard_clockText__aC6q9 {
  font-size: 14px;
  color: white;
  font-weight: 500;
}

.PANCard_panDemoDiv__hwC7I {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
  margin-top: 30px;
  padding: 0 20px;
}

.PANCard_EnterYourPan__f9aWj {
  font-family: 'CircularXXWeb-Medium', sans-serif;
  font-size: 18px;
  color: #333;
  font-weight: 600;
}

.PANCard_panImage__cNBeO {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  transition: transform 0.3s ease;
}

.PANCard_panImage__cNBeO:hover {
  transform: scale(1.02);
}

.PANCard_SamplePANText__5K9NC {
  font-size: 13px;
  color: #888;
  font-weight: 500;
  font-style: italic;
}

.PANCard_panInputDiv__wG-3- {
  display: flex;
  flex-direction: column;
  padding: 0 10%;
  margin-top: 40px;
}

.PANCard_panLabel__94lTV {
  font-size: 14px;
  color: #555;
  margin-left: 2px;
  margin-bottom: 8px;
  font-weight: 500;
}

.PANCard_panInput__IWPqB {
  border: none;
  border-bottom: 2px solid #fa7a70;
  border-top: none;
  border-left: none;
  border-right: none;
  outline: none;
  font-size: 18px;
  color: #333;
  padding: 10px 5px;
  background-color: transparent;
  transition: all 0.3s ease;
  letter-spacing: 1px;
}

.PANCard_panInput__IWPqB::placeholder {
  color: #bbb;
  font-size: 16px;
}

.PANCard_panInput__IWPqB:focus {
  border-bottom: 2px solid #f44336;
  box-shadow: 0 4px 6px -6px #f44336;
}

.PANCard_errorMessage__zgOpW {
  font-size: 13px;
  color: #f05156;
  margin-top: 8px;
  font-weight: 500;
  animation: PANCard_shake__PpUxR 0.5s ease-in-out;
}

@keyframes PANCard_shake__PpUxR {
  0%, 100% { transform: translateX(0); }
  20%, 60% { transform: translateX(-5px); }
  40%, 80% { transform: translateX(5px); }
}

.PANCard_shieldDiv__jOmUj {
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 80%;
  margin: 0 auto;
  justify-content: center;
  margin-top: 40px;
  background-color: #f9f9f9;
  padding: 12px;
  border-radius: 8px;
}

.PANCard_shieldIcon__bb9Ii {
  width: 20px;
  height: 20px;
}

.PANCard_shieldText__EaLqv {
  font-size: 14px;
  color: #666;
  margin-left: 10px;
  font-weight: 500;
}

.PANCard_Line__vvcJs {
  border-bottom: 1px solid #f0f0f0;
  margin-top: 40px;
}

.PANCard_verifyButton__rBmsg {
  background-image: linear-gradient(to right, #f73439, #ff7676) !important;
  font-size: 16px;
  font-weight: 500;
  color: #fff;
  border-radius: 8px !important;
  border: none;
  cursor: pointer;
  padding: 12px 40px;
  margin: 25px auto;
  display: block;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(247, 52, 57, 0.3);
}

.PANCard_verifyButton__rBmsg:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 18px rgba(247, 52, 57, 0.4);
}

.PANCard_verifyButton__rBmsg:active {
  transform: translateY(1px);
  box-shadow: 0 2px 10px rgba(247, 52, 57, 0.3);
}

/* Loader Styles */
.PANCard_loader__85E\\+E {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.9);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  backdrop-filter: blur(5px);
}

/* Fix for KYCiconsPAN icon */
[src*="KYCiconsPAN"] {
  display: block !important;
  width: 32px !important;
  height: 32px !important;
  object-fit: contain !important;
}

.PANCard_loaderDiv__yYObl {
  background-color: white;
  border-radius: 16px;
  padding: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  max-width: 90%;
  width: 450px;
  position: relative;
}

.PANCard_loaderDiv__yYObl::before {
  content: "";
  position: absolute;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  width: 50px;
  height: 50px;
  border: 3px solid #f0f0f0;
  border-top: 3px solid #f73439;
  border-radius: 50%;
  animation: PANCard_spin__dY\\+bi 1s linear infinite;
}

@keyframes PANCard_spin__dY\\+bi {
  0% { transform: translateX(-50%) rotate(0deg); }
  100% { transform: translateX(-50%) rotate(360deg); }
}

.PANCard_fetchingText__0p142 {
  font-size: 20px;
  font-weight: 600;
  color: #333;
  margin-top: 60px;
  text-align: center;
}

.PANCard_loadingText__Pvvwr {
  font-size: 14px;
  color: #777;
  text-align: center;
  line-height: 1.5;
}

/* Confirmation Modal Styles */
.PANCard_confirmationDiv__RD1kv {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  backdrop-filter: blur(3px);
}

.PANCard_confirmationWrapper__yisJh {
  background-color: #fff;
  border-radius: 16px;
  padding: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  max-width: 90%;
  width: 500px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.2);
  animation: PANCard_modalFadeIn__TMykf 0.3s ease-out;
}

@keyframes PANCard_modalFadeIn__TMykf {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}

.PANCard_modalHeader__EHwVi {
  width: 100%;
  text-align: center;
  position: relative;
  margin-bottom: 10px;
}

.PANCard_modalHeader__EHwVi h2 {
  font-size: 20px;
  color: #333;
  margin: 0 0 10px;
  font-weight: 600;
  line-height: 1.4;
  max-width:90% ;
  text-align: center;
  margin: 0 auto;
}

.PANCard_closeButton__-Lord {
  position: absolute;
  top: -10px;
  right: -10px;
  background: #f73439;
  color: white;
  border: none;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  font-size: 18px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.PANCard_confirmationItemDiv__8M3cA {
  width: 100%;
  padding: 0 20px;
  overflow: visible;
}

/* PAN Card Design */
.PANCard_PanDesign__tEkIk {
  width: 100%;
  max-width: 340px;
  /* aspect-ratio: 85.60 / 53.98; */
  background: linear-gradient(135deg, #e8c5d3, #9fc9eb);
  border: none;
  border-radius: 12px;
  align-items: center;
  padding: 15px 20px;
  margin: 15px auto;
  position: relative;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
  /* overflow: hidden; */
}

.PANCard_PanDesign__tEkIk::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  opacity: 0.3;
  pointer-events: none;
}

.PANCard_PanInner__3tKvu {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.PANCard_PanAuthority__wOewV {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.PANCard_PanAuthorityText__pZs4s {
  font-size: 10px;
  font-weight: 600;
  color: #333;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.PANCard_LionImage__aCqma {
  height: 30px;
  width: auto;
}

.PANCard_PanNumberContainer__2khja {
  margin: 10px 0;
  background-color: rgba(255, 255, 255, 0.7);
  padding: 8px 12px;
  border-radius: 8px;
  position: relative;
}

.PANCard_PanNumberHeading__nIHy1 {
  font-size: 10px;
  color: #555;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-weight: 600;
}

.PANCard_PanNumberText__vh5f- {
  font-size: 18px;
  font-weight: 700;
  color: #333;
  letter-spacing: 1px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.PANCard_editIcon__-9JbF {
  width: 18px;
  height: 18px;
  cursor: pointer;
  opacity: 0.7;
  transition: all 0.2s ease;
}

.PANCard_editIcon__-9JbF:hover {
  opacity: 1;
  transform: scale(1.1);
}

.PANCard_PanDetailContainerTop__wMQHb,
.PANCard_PanDetailContainer__5K70A {
  background-color: rgba(255, 255, 255, 0.5);
  padding: 12px 15px;
  border-radius: 8px;
  margin-bottom: 12px;
  min-height: 60px;
  overflow: visible;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.PANCard_PanNameContainer__BPnaj {
  display: flex;
  flex-direction: column;
}

.PANCard_PanName__FBiku {
  font-size: 10px;
  color: #555;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-weight: 600;
}

.PANCard_PanNameValue__Vd0V3 {
  font-size: 14px;
  font-weight: 600;
  color: #333;
  margin-top: 2px;
  word-break: break-word;
  line-height: 1.4;
}

.PANCard_confirmButton__3xJv-,
.PANCard_submitButton__ZBIdH {
  background-image: linear-gradient(to right, #f73439, #ff7676);
  font-size: 16px;
  font-weight: 500;
  color: #fff;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  padding: 12px 40px;
  margin: 15px auto 10px;
  display: block;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(247, 52, 57, 0.3);
  width: 100%;
  max-width: 200px;
}

.PANCard_confirmButton__3xJv-:hover,
.PANCard_submitButton__ZBIdH:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 18px rgba(247, 52, 57, 0.4);
}

.PANCard_nomineeDetailsInput__RqC0T {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  color: #333;
  outline: none;
  transition: all 0.3s ease;
  margin-bottom: 8px;
}

.PANCard_confirmationWrapper__yisJh p {
  color: #f05156;
  font-size: 14px;
  margin: 5px 0;
  text-align: center;
  font-weight: 500;
  animation: PANCard_shake__PpUxR 0.5s ease-in-out;
}

.PANCard_nomineeDetailsInput__RqC0T:focus {
  border-color: #f73439;
  box-shadow: 0 0 0 2px rgba(247, 52, 57, 0.1);
}

.PANCard_dropZone__ix5Ac {
  border: 2px dashed #90caf9;
  border-radius: 10px;
  /* padding: 40px 20px; */
  text-align: center;
  width: 100%;
  margin: auto;
}

.PANCard_dropZoneActive__88j9D {
  border-color: #1976d2;
  background-color: rgba(25, 118, 210, 0.06);
}

.PANCard_hint__vLdQD {
  margin: 10px 0 0;
  font-size: 13px;
  color: #666;
}

.PANCard_selectedFile__FnFR6 {
  margin: 10px 0 0;
  font-size: 13px;
  color: #333;
  word-break: break-word;
}

.PANCard_panPreview__GdFov {
  width: 100%;
  max-height: 220px;
  object-fit: contain;
  border-radius: 10px;
  margin: 12px 0 0;
  background-color: #f7f7f7;
}

.PANCard_fileActionRow__fYBOm {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin: 12px 0 12px;
}

.PANCard_submitButtonSmall__0C1h4 {
  background-color: #16a34a;
  color: white;
  padding: 8px 20px;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  font-size: 14px;
}

.PANCard_submitButtonSmall__0C1h4:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.PANCard_uploadIcon__2JhUf {
  font-size: 40px;
  color: #2196f3;
  margin-bottom: 12px;
}

.PANCard_fileInput__SZ4HP {
  display: none; /* hide the default ugly input */
  width: 100%;
  height: 100%;
}

.PANCard_browseButton__SAqYT {
  background-color: #2196f3;
  color: white;
  padding: 8px 20px;
  margin: 12px 0;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  font-size: 14px;
  display: inline-block;
  transition: background 0.2s ease;
}

.PANCard_browseButton__SAqYT:hover {
  background-color: #1976d2;
}


/* Responsive Styles */
@media (max-width: 768px) {
  .PANCard_MainContainer__axLvn {
    padding: 20px 15px;
  }
  
  .PANCard_MainWrapper__irosl {
    width: 100%;
  }
  
  .PANCard_panInputDiv__wG-3- {
    padding: 0 5%;
  }
  
  .PANCard_topPanText__TOt7\\+ {
    font-size: 18px;
  }
  
  .PANCard_confirmationWrapper__yisJh {
    width: 90%;
    padding: 20px;
  }
  
  .PANCard_PanDesign__tEkIk {
    max-width: 300px;
  }
}

@media (max-width: 480px) {
  .PANCard_topPANDiv__IihO1 {
    flex-direction: column;
    gap: 10px;
    padding: 15px;
    text-align: center;
  }
  
  .PANCard_topClockDiv__gpipN {
    margin-top: 10px;
  }
  
  .PANCard_panInputDiv__wG-3- {
    margin-top: 30px;
  }
  
  .PANCard_verifyButton__rBmsg {
    padding: 10px 30px;
  }
  
  .PANCard_PanDesign__tEkIk {
    max-width: 280px;
    padding: 10px 15px;
  }
  
  .PANCard_modalHeader__EHwVi h2 {
    font-size: 16px;
    line-height: 1.4;
    padding: 0 10px;
  }
  
  .PANCard_confirmationWrapper__yisJh {
    padding: 20px 15px;
  }
  
  .PANCard_PanNameValue__Vd0V3 {
    font-size: 13px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/organism/PANCard.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,2CAA2C;EAC3C,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gCAAgC;EAChC,aAAa;EACb,qDAAqD;EACrD,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,aAAa;EACb,0CAA0C;EAC1C,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,+CAA+C;EAC/C,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;EAC1C,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gCAAgC;EAChC,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,6BAA6B;EAC7B,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gDAAiC;AACnC;;AAEA;EACE,WAAW,wBAAwB,EAAE;EACrC,WAAW,2BAA2B,EAAE;EACxC,WAAW,0BAA0B,EAAE;AACzC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,cAAc;EACd,uBAAuB;EACvB,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,wEAAwE;EACxE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,6BAA6B;EAC7B,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,0BAA0B;EAC1B,6CAA6C;AAC/C;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,0BAA0B;AAC5B;;AAEA,6BAA6B;AAC7B;EACE,yBAAyB;EACzB,sBAAsB;EACtB,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,0CAA0C;EAC1C,cAAc;EACd,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kDAAkC;AACpC;;AAEA;EACE,KAAK,wCAAwC,EAAE;EAC/C,OAAO,0CAA0C,EAAE;AACrD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,8BAA8B;AAC9B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;EAC1C,mDAAoC;AACtC;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;AACnB;;AAEA,oBAAoB;AACpB;EACE,WAAW;EACX,gBAAgB;EAChB,iCAAiC;EACjC,qDAAqD;EACrD,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,0CAA0C;EAC1C,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,mDAAoO;EACpO,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,cAAc;EACd,0CAA0C;EAC1C,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,qBAAqB;AACvB;;AAEA;;EAEE,0CAA0C;EAC1C,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;;EAEE,6DAA6D;EAC7D,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;EACd,yBAAyB;EACzB,6CAA6C;EAC7C,WAAW;EACX,gBAAgB;AAClB;;AAEA;;EAEE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,gDAAiC;AACnC;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,wBAAwB;EACxB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa,EAAE,gCAAgC;EAC/C,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA,sBAAsB;AACtB;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,SAAS;IACT,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".MainContainer {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 30px 20px;\n  min-height: 100vh;\n  background-color: #f8f9fa;\n}\n\n.MainWrapper {\n  border: none;\n  border-radius: 16px;\n  background-color: #fff;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);\n  width: 100%;\n  max-width: 550px;\n  height: 100%;\n  overflow: hidden;\n  transition: all 0.3s ease;\n}\n\n.topPANDiv {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  border-bottom: 1px solid #f0f0f0;\n  padding: 20px;\n  background: linear-gradient(135deg, #ff7676, #f73439);\n  color: white;\n}\n\n.topPanIcon {\n  width: 32px;\n  height: 32px;\n  object-fit: contain;\n  display: block;\n}\n\n.topPanText {\n  font-size: 22px;\n  font-weight: 600;\n  line-height: 28px;\n  color: white;\n  margin-top: 0;\n  flex-grow: 1;\n}\n\n.topClockDiv {\n  display: flex;\n  gap: 8px;\n  margin-top: 0;\n  background-color: rgba(255, 255, 255, 0.2);\n  padding: 6px 12px;\n  border-radius: 20px;\n}\n\n.clockIcon {\n  height: 18px;\n  width: 18px;\n  align-self: center;\n}\n\n.clockText {\n  font-size: 14px;\n  color: white;\n  font-weight: 500;\n}\n\n.panDemoDiv {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 15px;\n  margin-top: 30px;\n  padding: 0 20px;\n}\n\n.EnterYourPan {\n  font-family: 'CircularXXWeb-Medium', sans-serif;\n  font-size: 18px;\n  color: #333;\n  font-weight: 600;\n}\n\n.panImage {\n  max-width: 100%;\n  height: auto;\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n  transition: transform 0.3s ease;\n}\n\n.panImage:hover {\n  transform: scale(1.02);\n}\n\n.SamplePANText {\n  font-size: 13px;\n  color: #888;\n  font-weight: 500;\n  font-style: italic;\n}\n\n.panInputDiv {\n  display: flex;\n  flex-direction: column;\n  padding: 0 10%;\n  margin-top: 40px;\n}\n\n.panLabel {\n  font-size: 14px;\n  color: #555;\n  margin-left: 2px;\n  margin-bottom: 8px;\n  font-weight: 500;\n}\n\n.panInput {\n  border: none;\n  border-bottom: 2px solid #fa7a70;\n  border-top: none;\n  border-left: none;\n  border-right: none;\n  outline: none;\n  font-size: 18px;\n  color: #333;\n  padding: 10px 5px;\n  background-color: transparent;\n  transition: all 0.3s ease;\n  letter-spacing: 1px;\n}\n\n.panInput::placeholder {\n  color: #bbb;\n  font-size: 16px;\n}\n\n.panInput:focus {\n  border-bottom: 2px solid #f44336;\n  box-shadow: 0 4px 6px -6px #f44336;\n}\n\n.errorMessage {\n  font-size: 13px;\n  color: #f05156;\n  margin-top: 8px;\n  font-weight: 500;\n  animation: shake 0.5s ease-in-out;\n}\n\n@keyframes shake {\n  0%, 100% { transform: translateX(0); }\n  20%, 60% { transform: translateX(-5px); }\n  40%, 80% { transform: translateX(5px); }\n}\n\n.shieldDiv {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  max-width: 80%;\n  margin: 0 auto;\n  justify-content: center;\n  margin-top: 40px;\n  background-color: #f9f9f9;\n  padding: 12px;\n  border-radius: 8px;\n}\n\n.shieldIcon {\n  width: 20px;\n  height: 20px;\n}\n\n.shieldText {\n  font-size: 14px;\n  color: #666;\n  margin-left: 10px;\n  font-weight: 500;\n}\n\n.Line {\n  border-bottom: 1px solid #f0f0f0;\n  margin-top: 40px;\n}\n\n.verifyButton {\n  background-image: linear-gradient(to right, #f73439, #ff7676) !important;\n  font-size: 16px;\n  font-weight: 500;\n  color: #fff;\n  border-radius: 8px !important;\n  border: none;\n  cursor: pointer;\n  padding: 12px 40px;\n  margin: 25px auto;\n  display: block;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 15px rgba(247, 52, 57, 0.3);\n}\n\n.verifyButton:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 18px rgba(247, 52, 57, 0.4);\n}\n\n.verifyButton:active {\n  transform: translateY(1px);\n  box-shadow: 0 2px 10px rgba(247, 52, 57, 0.3);\n}\n\n/* Loader Styles */\n.loader {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(255, 255, 255, 0.9);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  backdrop-filter: blur(5px);\n}\n\n/* Fix for KYCiconsPAN icon */\n[src*=\"KYCiconsPAN\"] {\n  display: block !important;\n  width: 32px !important;\n  height: 32px !important;\n  object-fit: contain !important;\n}\n\n.loaderDiv {\n  background-color: white;\n  border-radius: 16px;\n  padding: 30px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 20px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);\n  max-width: 90%;\n  width: 450px;\n  position: relative;\n}\n\n.loaderDiv::before {\n  content: \"\";\n  position: absolute;\n  top: 20px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 50px;\n  height: 50px;\n  border: 3px solid #f0f0f0;\n  border-top: 3px solid #f73439;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% { transform: translateX(-50%) rotate(0deg); }\n  100% { transform: translateX(-50%) rotate(360deg); }\n}\n\n.fetchingText {\n  font-size: 20px;\n  font-weight: 600;\n  color: #333;\n  margin-top: 60px;\n  text-align: center;\n}\n\n.loadingText {\n  font-size: 14px;\n  color: #777;\n  text-align: center;\n  line-height: 1.5;\n}\n\n/* Confirmation Modal Styles */\n.confirmationDiv {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.7);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  backdrop-filter: blur(3px);\n}\n\n.confirmationWrapper {\n  background-color: #fff;\n  border-radius: 16px;\n  padding: 30px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 20px;\n  max-width: 90%;\n  width: 500px;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.2);\n  animation: modalFadeIn 0.3s ease-out;\n}\n\n@keyframes modalFadeIn {\n  from { opacity: 0; transform: translateY(20px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n.modalHeader {\n  width: 100%;\n  text-align: center;\n  position: relative;\n  margin-bottom: 10px;\n}\n\n.modalHeader h2 {\n  font-size: 20px;\n  color: #333;\n  margin: 0 0 10px;\n  font-weight: 600;\n  line-height: 1.4;\n  max-width:90% ;\n  text-align: center;\n  margin: 0 auto;\n}\n\n.closeButton {\n  position: absolute;\n  top: -10px;\n  right: -10px;\n  background: #f73439;\n  color: white;\n  border: none;\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  font-size: 18px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);\n}\n\n.confirmationItemDiv {\n  width: 100%;\n  padding: 0 20px;\n  overflow: visible;\n}\n\n/* PAN Card Design */\n.PanDesign {\n  width: 100%;\n  max-width: 340px;\n  /* aspect-ratio: 85.60 / 53.98; */\n  background: linear-gradient(135deg, #e8c5d3, #9fc9eb);\n  border: none;\n  border-radius: 12px;\n  align-items: center;\n  padding: 15px 20px;\n  margin: 15px auto;\n  position: relative;\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);\n  /* overflow: hidden; */\n}\n\n.PanDesign::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: url('data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"100\" height=\"100\" viewBox=\"0 0 100 100\"><rect width=\"100\" height=\"100\" fill=\"none\" stroke=\"rgba(255,255,255,0.1)\" stroke-width=\"2\"/></svg>');\n  opacity: 0.3;\n  pointer-events: none;\n}\n\n.PanInner {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.PanAuthority {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 10px;\n}\n\n.PanAuthorityText {\n  font-size: 10px;\n  font-weight: 600;\n  color: #333;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.LionImage {\n  height: 30px;\n  width: auto;\n}\n\n.PanNumberContainer {\n  margin: 10px 0;\n  background-color: rgba(255, 255, 255, 0.7);\n  padding: 8px 12px;\n  border-radius: 8px;\n  position: relative;\n}\n\n.PanNumberHeading {\n  font-size: 10px;\n  color: #555;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  font-weight: 600;\n}\n\n.PanNumberText {\n  font-size: 18px;\n  font-weight: 700;\n  color: #333;\n  letter-spacing: 1px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.editIcon {\n  width: 18px;\n  height: 18px;\n  cursor: pointer;\n  opacity: 0.7;\n  transition: all 0.2s ease;\n}\n\n.editIcon:hover {\n  opacity: 1;\n  transform: scale(1.1);\n}\n\n.PanDetailContainerTop,\n.PanDetailContainer {\n  background-color: rgba(255, 255, 255, 0.5);\n  padding: 12px 15px;\n  border-radius: 8px;\n  margin-bottom: 12px;\n  min-height: 60px;\n  overflow: visible;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n}\n\n.PanNameContainer {\n  display: flex;\n  flex-direction: column;\n}\n\n.PanName {\n  font-size: 10px;\n  color: #555;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  font-weight: 600;\n}\n\n.PanNameValue {\n  font-size: 14px;\n  font-weight: 600;\n  color: #333;\n  margin-top: 2px;\n  word-break: break-word;\n  line-height: 1.4;\n}\n\n.confirmButton,\n.submitButton {\n  background-image: linear-gradient(to right, #f73439, #ff7676);\n  font-size: 16px;\n  font-weight: 500;\n  color: #fff;\n  border-radius: 8px;\n  border: none;\n  cursor: pointer;\n  padding: 12px 40px;\n  margin: 15px auto 10px;\n  display: block;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 15px rgba(247, 52, 57, 0.3);\n  width: 100%;\n  max-width: 200px;\n}\n\n.confirmButton:hover,\n.submitButton:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 18px rgba(247, 52, 57, 0.4);\n}\n\n.nomineeDetailsInput {\n  width: 100%;\n  padding: 10px 12px;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  font-size: 14px;\n  color: #333;\n  outline: none;\n  transition: all 0.3s ease;\n  margin-bottom: 8px;\n}\n\n.confirmationWrapper p {\n  color: #f05156;\n  font-size: 14px;\n  margin: 5px 0;\n  text-align: center;\n  font-weight: 500;\n  animation: shake 0.5s ease-in-out;\n}\n\n.nomineeDetailsInput:focus {\n  border-color: #f73439;\n  box-shadow: 0 0 0 2px rgba(247, 52, 57, 0.1);\n}\n\n.dropZone {\n  border: 2px dashed #90caf9;\n  border-radius: 10px;\n  /* padding: 40px 20px; */\n  text-align: center;\n  width: 100%;\n  margin: auto;\n}\n\n.dropZoneActive {\n  border-color: #1976d2;\n  background-color: rgba(25, 118, 210, 0.06);\n}\n\n.hint {\n  margin: 10px 0 0;\n  font-size: 13px;\n  color: #666;\n}\n\n.selectedFile {\n  margin: 10px 0 0;\n  font-size: 13px;\n  color: #333;\n  word-break: break-word;\n}\n\n.panPreview {\n  width: 100%;\n  max-height: 220px;\n  object-fit: contain;\n  border-radius: 10px;\n  margin: 12px 0 0;\n  background-color: #f7f7f7;\n}\n\n.fileActionRow {\n  display: flex;\n  justify-content: center;\n  gap: 10px;\n  margin: 12px 0 12px;\n}\n\n.submitButtonSmall {\n  background-color: #16a34a;\n  color: white;\n  padding: 8px 20px;\n  border-radius: 6px;\n  border: none;\n  cursor: pointer;\n  font-size: 14px;\n}\n\n.submitButtonSmall:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.uploadIcon {\n  font-size: 40px;\n  color: #2196f3;\n  margin-bottom: 12px;\n}\n\n.fileInput {\n  display: none; /* hide the default ugly input */\n  width: 100%;\n  height: 100%;\n}\n\n.browseButton {\n  background-color: #2196f3;\n  color: white;\n  padding: 8px 20px;\n  margin: 12px 0;\n  border-radius: 6px;\n  border: none;\n  cursor: pointer;\n  font-size: 14px;\n  display: inline-block;\n  transition: background 0.2s ease;\n}\n\n.browseButton:hover {\n  background-color: #1976d2;\n}\n\n\n/* Responsive Styles */\n@media (max-width: 768px) {\n  .MainContainer {\n    padding: 20px 15px;\n  }\n  \n  .MainWrapper {\n    width: 100%;\n  }\n  \n  .panInputDiv {\n    padding: 0 5%;\n  }\n  \n  .topPanText {\n    font-size: 18px;\n  }\n  \n  .confirmationWrapper {\n    width: 90%;\n    padding: 20px;\n  }\n  \n  .PanDesign {\n    max-width: 300px;\n  }\n}\n\n@media (max-width: 480px) {\n  .topPANDiv {\n    flex-direction: column;\n    gap: 10px;\n    padding: 15px;\n    text-align: center;\n  }\n  \n  .topClockDiv {\n    margin-top: 10px;\n  }\n  \n  .panInputDiv {\n    margin-top: 30px;\n  }\n  \n  .verifyButton {\n    padding: 10px 30px;\n  }\n  \n  .PanDesign {\n    max-width: 280px;\n    padding: 10px 15px;\n  }\n  \n  .modalHeader h2 {\n    font-size: 16px;\n    line-height: 1.4;\n    padding: 0 10px;\n  }\n  \n  .confirmationWrapper {\n    padding: 20px 15px;\n  }\n  \n  .PanNameValue {\n    font-size: 13px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"MainContainer": `PANCard_MainContainer__axLvn`,
	"MainWrapper": `PANCard_MainWrapper__irosl`,
	"topPANDiv": `PANCard_topPANDiv__IihO1`,
	"topPanIcon": `PANCard_topPanIcon__hzIrF`,
	"topPanText": `PANCard_topPanText__TOt7+`,
	"topClockDiv": `PANCard_topClockDiv__gpipN`,
	"clockIcon": `PANCard_clockIcon__7Na5s`,
	"clockText": `PANCard_clockText__aC6q9`,
	"panDemoDiv": `PANCard_panDemoDiv__hwC7I`,
	"EnterYourPan": `PANCard_EnterYourPan__f9aWj`,
	"panImage": `PANCard_panImage__cNBeO`,
	"SamplePANText": `PANCard_SamplePANText__5K9NC`,
	"panInputDiv": `PANCard_panInputDiv__wG-3-`,
	"panLabel": `PANCard_panLabel__94lTV`,
	"panInput": `PANCard_panInput__IWPqB`,
	"errorMessage": `PANCard_errorMessage__zgOpW`,
	"shake": `PANCard_shake__PpUxR`,
	"shieldDiv": `PANCard_shieldDiv__jOmUj`,
	"shieldIcon": `PANCard_shieldIcon__bb9Ii`,
	"shieldText": `PANCard_shieldText__EaLqv`,
	"Line": `PANCard_Line__vvcJs`,
	"verifyButton": `PANCard_verifyButton__rBmsg`,
	"loader": `PANCard_loader__85E+E`,
	"loaderDiv": `PANCard_loaderDiv__yYObl`,
	"spin": `PANCard_spin__dY+bi`,
	"fetchingText": `PANCard_fetchingText__0p142`,
	"loadingText": `PANCard_loadingText__Pvvwr`,
	"confirmationDiv": `PANCard_confirmationDiv__RD1kv`,
	"confirmationWrapper": `PANCard_confirmationWrapper__yisJh`,
	"modalFadeIn": `PANCard_modalFadeIn__TMykf`,
	"modalHeader": `PANCard_modalHeader__EHwVi`,
	"closeButton": `PANCard_closeButton__-Lord`,
	"confirmationItemDiv": `PANCard_confirmationItemDiv__8M3cA`,
	"PanDesign": `PANCard_PanDesign__tEkIk`,
	"PanInner": `PANCard_PanInner__3tKvu`,
	"PanAuthority": `PANCard_PanAuthority__wOewV`,
	"PanAuthorityText": `PANCard_PanAuthorityText__pZs4s`,
	"LionImage": `PANCard_LionImage__aCqma`,
	"PanNumberContainer": `PANCard_PanNumberContainer__2khja`,
	"PanNumberHeading": `PANCard_PanNumberHeading__nIHy1`,
	"PanNumberText": `PANCard_PanNumberText__vh5f-`,
	"editIcon": `PANCard_editIcon__-9JbF`,
	"PanDetailContainerTop": `PANCard_PanDetailContainerTop__wMQHb`,
	"PanDetailContainer": `PANCard_PanDetailContainer__5K70A`,
	"PanNameContainer": `PANCard_PanNameContainer__BPnaj`,
	"PanName": `PANCard_PanName__FBiku`,
	"PanNameValue": `PANCard_PanNameValue__Vd0V3`,
	"confirmButton": `PANCard_confirmButton__3xJv-`,
	"submitButton": `PANCard_submitButton__ZBIdH`,
	"nomineeDetailsInput": `PANCard_nomineeDetailsInput__RqC0T`,
	"dropZone": `PANCard_dropZone__ix5Ac`,
	"dropZoneActive": `PANCard_dropZoneActive__88j9D`,
	"hint": `PANCard_hint__vLdQD`,
	"selectedFile": `PANCard_selectedFile__FnFR6`,
	"panPreview": `PANCard_panPreview__GdFov`,
	"fileActionRow": `PANCard_fileActionRow__fYBOm`,
	"submitButtonSmall": `PANCard_submitButtonSmall__0C1h4`,
	"uploadIcon": `PANCard_uploadIcon__2JhUf`,
	"fileInput": `PANCard_fileInput__SZ4HP`,
	"browseButton": `PANCard_browseButton__SAqYT`
};
export default ___CSS_LOADER_EXPORT___;
